"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var listViewBitFlagsUtil_1 = require("owa-bit-flags/lib/utils/listViewBitFlagsUtil");
var store_1 = require("../store/store");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    viewStateConfiguration: function () { return owa_session_store_1.getUserConfiguration().ViewStateConfiguration; },
})(function IsDateHeadersDirty(state) {
    return (state.optionState.isEnabled !== null &&
        state.optionState.isEnabled == listViewBitFlagsUtil_1.getIsBitSet(2 /* DateHeadersDisabled */));
});
//# sourceMappingURL=isDateHeadersOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-date-headers-option/lib/utils/isDateHeadersOptionDirty.js
// module id = 5083
// module chunks = 2